import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { IClientContactPerson } from "../../models/ClientContactPerson";
import { IVendorCompanyMast } from "../../models/VendorCompanyMast";
import { EmptyNonPerformingVendor } from "./EmptyNonPerformingVendor";
// import { EmptyVendorCompany } from "../vendorCompanyMast/EmptyVendorCompany";
// import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { Form } from "./Form";
// import { VCMForm } from "./VCMForm";

export interface IModel1 {
    open: boolean,
    singleData: IClientContactPerson
}
export interface IModel2 {
    open: boolean,
    singleData: IVendorCompanyMast
}

export const NonPerformingVendor = (permissions: IPermissionProps) => {

    const [modal1, setModal1] = useState({ singleData: EmptyNonPerformingVendor, open: false } as IModel1);
    // const [modal2, setModal2] = useState({ singleData: EmptyVendorCompany, open: false } as IModel2);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog1 = () => {
        setModal1({ singleData: EmptyNonPerformingVendor, open: false });
    };
    // const hideDialog2 = () => {
    //     setModal2({ singleData: EmptyVendorCompany, open: false });
    // };
    // const openNewForm = () => {
    //     setModal2({ singleData: EmptyVendorCompany, open: true });
    // }

    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form setModal={setModal1} singleData={modal1.singleData} open={modal1.open} hideDialog={hideDialog1} toast={toast} reload={reload} setReload={setReload}></Form>}
            {permissions.is_View && <Table permissions={permissions} setModal={setModal1} toast={toast} reload={reload} setReload={setReload}></Table>}
            <Toast ref={toast} />
        </>
    );
}